var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2237_8554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19421 0.0078125C9.04823 1.24471 9.71375 2.60166 10.1689 4.03415C11.2106 3.87075 12.2138 3.51931 13.1297 2.99704L13.3985 2.83036C12.1234 1.21664 10.2423 0.196415 8.19421 0.0078125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38169 5.2417C8.75701 5.31324 8.12873 5.34915 7.49998 5.34922C6.87121 5.34912 6.24296 5.31324 5.61828 5.2417C5.48556 5.807 5.40104 6.38254 5.3656 6.96212H9.6344C9.59896 6.38254 9.51441 5.807 9.38169 5.2417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49997 10.7256C6.97023 10.7261 6.44087 10.7535 5.91394 10.8078C6.30157 11.9653 6.83452 13.0689 7.49997 14.0922C8.16542 13.0689 8.69834 11.9653 9.086 10.8078C8.55907 10.7535 8.02971 10.7261 7.49997 10.7256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7053 8.03711C10.6725 8.67147 10.5868 9.30201 10.4489 9.92206C11.5935 10.1122 12.6944 10.5078 13.6983 11.0898L14.0021 11.279C14.5787 10.2891 14.9201 9.17994 14.9999 8.03711H10.7053V8.03711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0021 3.72119L13.6983 3.91046C12.6946 4.49337 11.5937 4.88988 10.4489 5.08088C10.5866 5.6999 10.6724 6.32931 10.7053 6.96259H14.9999C14.92 5.81995 14.5786 4.71098 14.0021 3.72119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36548 8.03711C5.40123 8.61675 5.48613 9.19229 5.61923 9.75753C6.86963 9.6147 8.13223 9.6147 9.38267 9.75753C9.51504 9.19219 9.59922 8.61665 9.63428 8.03711H5.36548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3016 3.91046L0.997826 3.72119C0.421339 4.71098 0.0799521 5.81995 0 6.96259H4.29464C4.32759 6.32931 4.41337 5.69986 4.5511 5.08088C3.40622 4.88988 2.30532 4.49337 1.3016 3.91046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83124 10.9663C3.78972 11.1298 2.78654 11.481 1.87049 12.0029L1.60168 12.1701C2.8767 13.7839 4.75793 14.804 6.80598 14.9921C5.95183 13.7555 5.28632 12.3987 4.83124 10.9663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49997 0.907715C6.83462 1.9309 6.3017 3.03432 5.91394 4.19158C6.44084 4.2462 6.97023 4.27364 7.49997 4.27383C8.02971 4.27364 8.55907 4.24617 9.086 4.19158C8.69825 3.03432 8.16533 1.9309 7.49997 0.907715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1296 12.0024C12.2135 11.4805 11.2104 11.1293 10.1688 10.9658C9.7133 12.3983 9.04722 13.7551 8.1925 14.9916C10.2406 14.8035 12.1218 13.7834 13.3968 12.1696L13.1296 12.0024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60315 2.83085L1.87035 2.99753C2.78627 3.5198 3.78948 3.8712 4.8311 4.03464C5.28677 2.60202 5.95285 1.2451 6.80744 0.00830078C4.7594 0.196872 2.87829 1.2171 1.60315 2.83085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29464 8.03711H0C0.0798576 9.17994 0.421245 10.2891 0.997858 11.279L1.30163 11.0898C2.30554 10.5078 3.40641 10.1122 4.5511 9.92206C4.41315 9.30198 4.32737 8.67147 4.29464 8.03711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2237_8554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalLogo);
export default __webpack_public_path__ + "static/media/GlobalLogo.978af0fa48c857b364fcb28f77fc2d1f.svg";
export { ForwardRef as ReactComponent };